import React, { Component } from 'react';
import InputMask from 'react-input-mask';

export class OtherCheckbox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    var key = this.props.details.other_id;
    return (
      <div className="row">
        <div className="col-md-4" key={key}>
          <div className="checkbox">
            <label>
              <input type="checkbox" checked={this.props.details.selected} onChange={this.props.onCheck} id={key}/>
              <InputMask type="text" className="form-control input-sm" onChange={this.props.mobileInput} id={key} value={this.props.details.mobile} mask={"(999) 999-9999"}/>
            </label>
            <a className="button" className="close" onClick={this.props.removeOther} id={key}>&times;</a>
          </div>
        </div>
      </div>
    );
  }
}
